import { Dropdown, IDropdownOption, Spinner } from "@fluentui/react";
import { dropdownStylesSingle } from "../../Styles/DropDownStyles";
import { useEffect, useState } from "react";
import PortfolioService from "../../../../../services/PortfolioService";
import { TDiversificationScreen, TDiversificationScreenSaved } from "../../types/DiversificacionCarteraTypes";
import MiniCards from "../../../../../components/MiniCards/MiniCards";
import { FormatMiniTableData } from "../../Util/FormatMiniTableData";
import PieHighstock from "../../../../../components/Highstock/PieHighstock";
import { FormatCircleGraphData } from "../../Util/FormatCircleGraphData";
import TableCustom from "../../TableCustom/TableCustom";
import { FormatTableData } from "../../Util/FormatTableData";
import { INITIAL_SCREEN_DATA, INITIAL_CIRCLEGRAPH, INITIAL_CIRCLEGRAPH2, INITIAL_MINITABLE } from "./Diversification_InitialData";
import { TActivePlan } from "../../types/TActivePlan";
import HighchartWaterfall from "../../../../../components/HighChart_Waterfall/HighchartWaterfall";
import { FormatDataWaterfall } from "../../Util/FormatDataWaterfall";

const BASE_CLASS = "diversificacion";

type TDiversificacionProps = {
    activePlan: TActivePlan;
    options: IDropdownOption[];
}

const Diversificacion = ({ activePlan, options }: TDiversificacionProps) => {
    const [isloadingGraph, setIsloadingGraph] = useState<boolean>(true);
    const [wallet, setWallet] = useState<IDropdownOption>();
    const [diversificationScreen, setDiversificationScreen] = useState<TDiversificationScreen>(INITIAL_SCREEN_DATA);
    const [diversificationScreenSaved, setDiversificationScreenSaved] = useState<TDiversificationScreenSaved[]>([]);

    const onUpdateSelectionWallets = async (_: React.FormEvent<HTMLDivElement>, option: IDropdownOption | undefined): Promise<void> => {
        if (option?.key) {
            setWallet(option);
        }
        setIsloadingGraph(true);
    };

    const getDiversificationScreen = async (contrato: string): Promise<TDiversificationScreen> => {
        const dataExist = diversificationScreenSaved?.find(
            (dataSaved: TDiversificationScreenSaved) =>
                dataSaved.nomcontrato === contrato);

        return dataExist ?? await PortfolioService.GetDiversificationScreen(contrato)
            .then(result => {           
                const dataNomcontrato: TDiversificationScreenSaved = {
                    ...result, nomcontrato: contrato
                };
            setDiversificationScreenSaved(prevState => {
                const exists = prevState?.some(item => item.nomcontrato === contrato);

                return exists ? prevState : [...(prevState || []), dataNomcontrato];
            });            
            return result;            
        });
    };

    useEffect(() => {
        if (wallet) getDiversificationScreen(wallet?.key?.toString()).then(result => {
            setDiversificationScreen(result);
            setIsloadingGraph(false);
        })
    },[wallet]);

    useEffect(() => {
        getDiversificationScreen(activePlan.finametrixContract).then(result => {
            setDiversificationScreen(result);
            setIsloadingGraph(false);
        })
    },[])

    const circleGraphData = FormatCircleGraphData({ 
        activo1: diversificationScreen?.activo1Riesgo || INITIAL_CIRCLEGRAPH,
        activo1y2: diversificationScreen?.activo1y2Riesgo || INITIAL_CIRCLEGRAPH2
    });

    const miniTableData = 
        FormatMiniTableData({
            dataMiniCard: diversificationScreen?.miniTable || INITIAL_MINITABLE
    });

    const tableData =
        FormatTableData({
            tipoActivo1: diversificationScreen?.activo1,
            tipoActivo1y2: diversificationScreen?.activo1y2,
            maxDetail: diversificationScreen?.maxLevelDetail,
    });

    const waterfallData = FormatDataWaterfall({ dataWaterfall: diversificationScreen.waterfall})
    return (
        <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}__dropdown__container`}>
                <Dropdown placeholder={activePlan.name}
                    className={`${BASE_CLASS}__dropdown`}
                    options={options as IDropdownOption[]}
                    defaultSelectedKeys={[activePlan.finametrixContract]}
                    onChange={onUpdateSelectionWallets}
                    styles={dropdownStylesSingle}
                />
            </div>

            <MiniCards sections={miniTableData} />

            <div className={`${BASE_CLASS}__data__container`}>
                {isloadingGraph && <Spinner size={3} style={{ padding: "1em" }} />}
                <div className={`${BASE_CLASS}__graphs__container`}>
                    <div className={`${BASE_CLASS}__waterfallGraph__container`}>
                        <HighchartWaterfall name='Waterfall de Riesgo' data={waterfallData}/>
                    </div>
                    <div className={`${BASE_CLASS}__graphsCircle__container`}>
                        <span className={`${BASE_CLASS}__title__container`}>Desglose de Riesgo por Tipo de Activo</span>
                        <PieHighstock chartSerie={circleGraphData} showSubcategories={true} />
                    </div>
                </div>
                <div className={`${BASE_CLASS}__table__container`}>
                    <TableCustom tableData={tableData} totalRowData={diversificationScreen.inferior} />
                </div>
            </div>
        </div>
    );
}

export default Diversificacion;